<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdmit_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12.019 26c-.515 0-1.03-.206-1.423-.618l-8.007-8.41a2.187 2.187 0 0 1 0-2.987 1.943 1.943 0 0 1 2.844 0l6.586 6.916L26.567 5.619a1.943 1.943 0 0 1 2.844 0 2.187 2.187 0 0 1 0 2.987L13.44 25.38c-.393.413-.906.62-1.421.62"
    />
</svg>
